<template>
  <v-card>
    <v-card-title>
      <p class="pl-6">{{ $tc("skills.title", 2) }}</p>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('common.search')"
        single-line
        hide-details
      >
      </v-text-field>
    </v-card-title>
    <p class="pa-5">{{ $t("skills.description_grid") }}</p>
    <v-spacer></v-spacer>
    <v-form ref="form">
      <v-data-table
        ref="table"
        :headers="headers"
        :items="list"
        :loading="loading"
        item-key="number"
        class="elevation-1"
        :footer-props="footer"
        group-by="skill.category.id"
        :loading-text="$t('common.loading')"
        :no-results-text="$t('common.no_results')"
        :server-items-length="$store.state.skill_user.totalCount"
        :options.sync="options"
        dense
      >
        <template v-slot:group.header="{ items, isOpen, toggle }">
          <th colspan="4" @click="toggle">
            <v-icon>{{ isOpen ? "mdi-minus" : "mdi-plus" }} </v-icon>
            {{ items[0].skill.category.name | capitalize }}
          </th>
        </template>
        <template v-slot:no-data>
          {{ $t("common.no_results") }}
        </template>
        <template #item.name="{ item }">
          <p>
            <b>{{ item.skill.name }}</b>
          </p>
          <p class="font-italic" v-if="item.skill.classification">
            {{ $t("skills.classification") + ": " + item.skill.classification }}
          </p>
          <p class="font-italic">
            {{ item.count_interventions }}
            {{ $tc("skills.intervention_done", item.count_intervention) }}
          </p>
        </template>
        <template #item.goal_one="{ item }">
          <v-checkbox
            :disabled="!can_edit()"
            :label="item.skill.goal_one"
            @change="onChange(item)"
            v-model="item.goal_one_checked"
          />
        </template>
        <template #item.goal_two="{ item }">
          <v-checkbox
            v-if="item.skill.goal_two"
            :disabled="!can_edit()"
            :label="item.skill.goal_two"
            @change="onChange(item)"
            v-model="item.goal_two_checked"
          />
        </template>
        <template #item.goal_three="{ item }">
          <v-checkbox
            v-if="item.skill.goal_three"
            :disabled="!can_edit()"
            :label="item.skill.goal_three"
            @change="onChange(item)"
            v-model="item.goal_three_checked"
          />
        </template>
      </v-data-table>
    </v-form>
  </v-card>
</template>

<script>
import { ADD, FETCH, UPDATE } from "@/store/action-types"
import { mapActions } from "vuex"
import TableMixin from "@/mixins/TableMixin"
import FormMixin from "@/mixins/FormMixin"

export default {
  name: "PEFSkillsTable",
  mixins: [TableMixin, FormMixin],
  data: () => ({
    options: { itemsPerPage: -1 },
    afterLoadEnable: true,
  }),
  computed: {
    current_user() {
      return this.$store.state.user.profile
    },
    list() {
      return this.$store.state.skill_user.data
    },

    headers() {
      return [
        {
          value: "name",
          text: this.$tc("skills.subject", 1),
          sortable: false,
          width: "20%",
        },
        {
          value: "goal_one",
          text: this.$tc("skills.goal_one", 1),
          sortable: false,
        },
        {
          value: "goal_two",
          text: this.$tc("skills.goal_two", 1),
          sortable: false,
        },
        {
          value: "goal_three",
          text: this.$tc("skills.goal_three", 1),
          sortable: false,
        },
      ]
    },
  },
  watch: {
    "$route.params.user_id"() {
      // call the method which loads your initial state
      console.log("REFRESH")
      this.user_id_local = this.$route.params.user_id
      this.getDataFromApi()
    },
  },
  methods: {
    can_edit() {
      return !['PEF', 'ASPIRANT'].includes(this.current_user.role) && this.$store.state.user.item.can_edit
    },
    afterLoad() {
      let table = this.$refs.table
      let keys = Object.keys(table.$vnode.componentInstance.openCache)
      keys.forEach((x) => {
        table.$vnode.componentInstance.openCache[x] = false
      })
    },
    onChange(item) {
      this.formModel = item
      this.formModel.user = { id: this.user_id }
      this._submit()
    },
    ...mapActions("skill_user", [FETCH, UPDATE, ADD]),

    async _submit() {
      let fields = [
        "goal_one_checked",
        "goal_two_checked",
        "goal_three_checked",
        "skill",
        "user",
      ]
      if (this.formModel.id) {
        fields.push("id")
      }
      await this.submit(fields, null, "skill")
    },
  },

}
</script>
